import { createSlice } from "@reduxjs/toolkit";
import { deleteUser } from "../actions/adminUserManagement.action";
import { InitialState } from "../interfaces/userManagement.interface";

const initialState: InitialState = {
  isLoading: false,
  data: null,
};

const deleteUserAction = createSlice({
  name: "Delete User",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(deleteUser.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(deleteUser.fulfilled, (state) => {
      state.isLoading = false;
    });

    builder.addCase(deleteUser.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default deleteUserAction.reducer;
